<div class="row" data-testid="register-div">
  <form [formGroup]="registerForm" (ngSubmit)="onRegisterClicked()" data-testid="register-form">
    <h3 class="form-signin-heading">Register New Admin User</h3>
    <div class="form-group">
      <label for="inputUsername" class="">Username</label>
      <input type="text" name="inputUsername" class="form-control" placeholder="Username" formControlName="username" data-testid="user-field">
    </div>
    <div class="form-group">
      <label for="inputPassword">Password</label>
      <input type="password" name="inputPassword" class="form-control" placeholder="Password" formControlName="password" data-testid="password-field">
    </div>
    <div class="form-group">
      <label for="inputEmail">Email</label>
      <input type="email" name="inputEmail" class="form-control"placeholder="Email address" formControlName="email" data-testid="email-field">
    </div>
    <button class="btn btn-lg btn-primary btn-block" type="submit" data-testid="register-button">Register</button>

  </form>
</div>

